import { CreditCardService } from '../services/credit-card.service'
import { creditCardConstants } from '../constants'

/**
 * Loads the client's points information
 * @param {function} dispatch The redux dispatcher
 */
const getCards = () => async dispatch => {
	const {
		data: cards,
		success,
		errors
	} = await CreditCardService.getCreditCard()

	dispatch({
		type: creditCardConstants.GET_CARDS,
		payload: success ? cards : []
	})
}

/**
 * Loads the client's credit cards
 * @param {function} dispatch The redux dispatcher
 */
const getAllCards = () => async dispatch => {
	const {
		data: cards,
		success,
		errors
	} = await CreditCardService.getAllSavedCreditCards()

	dispatch({
		type: creditCardConstants.GET_ALL_CARDS,
		payload: success ? cards : []
	})
}

export const creditCardsActions = {
	getCards,
	getAllCards
}
